import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hub } from "../../pages/HubPage";
import { publicProfilePath } from "@/lib/publicProfileUrl";
import "./LeaderboardSection.css";

const BADGE_LABEL = {
  UNRANKED: "UNRANKED",
  QUALIFIED: "QUALIFIED",
  PROVEN: "PROVEN",
  ORACLE: "ORACLE",
  MASTER_PROPHET: "MASTER PROPHET",
};

export function LeaderboardSection() {
  const [state, setState] = useState({ loading: true, items: [], total: 0, minRes: 20 });

  useEffect(() => {
    hub.get("/hub/leaderboard/top?limit=5").then((r) => {
      setState({
        loading: false,
        items: r.data?.items || [],
        total: r.data?.eligible_total || 0,
        minRes: r.data?.min_resolved || 20,
      });
    }).catch(() => setState({ loading: false, items: [], total: 0, minRes: 20 }));
  }, []);

  return (
    <section className="hh-section hh-section--gold" data-testid="hh-leaderboard">
      <div className="hh-section-head">
        <h2 className="hh-section-title">LEADERBOARD</h2>
      </div>

      {state.loading ? (
        <div className="hh-section-body"><div className="hh-skeleton" style={{ height: 160 }} /></div>
      ) : state.items.length === 0 ? (
        <div className="hh-section-body" data-testid="lb-empty">
          <div className="lb-empty">
            <div className="lb-empty-title">NO PROPHETS HAVE QUALIFIED YET</div>
            <div className="lb-empty-sub">
              {state.minRes} resolved calls are required to enter the leaderboard.
            </div>
          </div>
        </div>
      ) : (
        <div className="hh-section-body lb-list" data-testid="lb-list">
          {state.items.map((row) => (
            <LbRow key={row.public_profile_id} row={row} />
          ))}
          <div className="lb-view-full-wrap">
            <Link to="/hub/leaderboard" data-testid="lb-view-full" className="lb-view-full">
              VIEW FULL LEADERBOARD →
            </Link>
          </div>
        </div>
      )}
    </section>
  );
}

function LbRow({ row }) {
  const top = row.rank <= 3;
  return (
    <Link to={publicProfilePath(row.public_profile_id) || "#"}
          data-testid={`lb-row-${row.rank}`}
          className={`lb-row${top ? " is-top" : ""}`}>
      <div className="lb-rank">#{row.rank}</div>
      <div className="lb-avatar">
        {row.avatar_url && <img src={row.avatar_url} alt="" />}
      </div>
      <div className="lb-name-col">
        <div className="lb-name" title={row.display_name}>{row.display_name}</div>
        <div className="lb-badge">{BADGE_LABEL[row.badge] || row.badge}</div>
      </div>
      <div className="lb-stat lb-stat--accuracy">
        <div className="lb-stat-value">
          {row.accuracy != null ? `${row.accuracy}%` : "—"}
        </div>
        <div className="lb-stat-label">ACCURACY</div>
      </div>
      <div className="lb-stat lb-stat--resolved">
        <div className="lb-stat-value">{row.resolved}</div>
        <div className="lb-stat-label">RESOLVED</div>
      </div>
    </Link>
  );
}

export default LeaderboardSection;
